import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("bigtek_admin_token")) navigate("/admin", { replace: true });
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", {
        email: email.trim(),
        password: password.trim(),
      });
      localStorage.setItem("bigtek_admin_token", data.token);
      toast.success("Signed in");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[hsl(222_47%_7%)] px-5">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="font-display text-2xl font-bold tracking-tight text-white">BIGTEK</div>
          <div className="mt-1 text-xs uppercase tracking-widest-xs text-slate-500">Admin access</div>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5 border border-slate-700 bg-[hsl(222_44%_12%)] p-8">
          <div className="flex items-center gap-2 text-slate-400">
            <Lock className="h-4 w-4" strokeWidth={1.5} />
            <span className="text-sm">Restricted area</span>
          </div>
          <div className="space-y-2">
            <Label htmlFor="a-email" className="text-slate-300">Username</Label>
            <Input id="a-email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)}
              autoCapitalize="none" autoCorrect="off" spellCheck={false} autoComplete="username"
              className="rounded-sm border-slate-600 bg-slate-900 text-white" autoFocus />
          </div>
          <div className="space-y-2">
            <Label htmlFor="a-pass" className="text-slate-300">Password</Label>
            <Input id="a-pass" type="password" data-testid="admin-password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoCapitalize="none" autoCorrect="off" spellCheck={false} autoComplete="current-password"
              className="rounded-sm border-slate-600 bg-slate-900 text-white" />
          </div>
          <Button type="submit" data-testid="admin-login-submit" disabled={loading}
            className="w-full rounded-sm bg-[hsl(var(--brand))] text-white hover:bg-[hsl(217_91%_53%)]">
            {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
